export default __webpack_public_path__ + "../staticImages/wsh_rabatt_gold-260.png";